import Color from 'color'
import { makeGrid } from '../../utils/GridCreator'
import { FeedingType, PrepaidType } from '../Object'
import fetchEvents from './fetchEvents'

export type StatusName =
  | 'Full'
  | 'NoPayment'
  | 'Advance'
  | 'Unavailable'
  | 'Canceled'

export enum EventStatus {
  Full = '1',
  NoPayment = '2',
  Advance = '3',
  Unavailable = '4',
  Canceled = '5',
}

export type EventRegistration = '0' | '1' | '2' // 0 - none, 1 - checkin, 2 - checkout

export type IEvent = IEventMain &
  IAdditionalInfo &
  IEventPerson &
  IEventPricing &
  IGuestInfo

export interface IEventMain {
  id: string
  roomId: string
  label?: string
  customColor?: Color

  startDate: Date
  finishDate: Date
  doorCode?: string
  airbnbId: string
  createdAt?: Date
  modifiedAt?: Date
  expiredAt?: Date
  isDeleted?: boolean

  doubleBed?: string
  singleBed?: string
  from_website?: number
  stage?: EventStatus
  company?: ICompany
  guest?: IGuestInfo
  roomMates?: IGuestInfo[]
  localTaxIncluded?: boolean

  bookingId?: string
  iCalendarId?: string
  paymentOnPlaceMethod?: string
  provisionMethod?: string

  /**
   * Denotes synchronization between event and booking
   */
  booking?: boolean
  /**
   * Denotes synchronization between event and iCalendar
   */
  iCalendar?: boolean
  isPast?: boolean
}

export interface IAdditionalInfo {
  arrivalTime?: Date | string
  departureTime?: Date | string

  adults?: number
  kids?: number
  kidsAge?: string[]

  notes?: string
  additionalServices?: IAdditionalService[]
  service?: FeedingType
}

export interface IEventPricing {
  price?: string
  pricePerDay?: string
  prepaidType?: PrepaidType
  paymentOnPlaceDate?: Date
  provisionDate?: Date
  priceType?: number
  dateToPayAfterStart?: Date
  paymentOnPlace?: string
  dateToPay?: Date
  localTax?: string
  deposit?: string
  provision?: string
  bookingPrice?: string

  _deposit?: string
  _localTax?: string
  _bookingPrice?: string
  _price?: string
  _pricePerDay?: string
  _provision?: string
}

export interface IEventPerson {
  provenance?: string
  registration?: EventRegistration
}

export interface IGuestInfo {
  name?: string
  street?: string
  houseNumber?: string
  apartmentNumber?: string
  city?: string
  postCode?: string
  country?: string
  passport?: string
  idCard?: string
  phone?: string
  email?: string
}

export interface ICompany {
  // to nie mapowane jeszcze bedzie nie wiadomo jak to coś wyglądać bedzie jeszcze xD
  name: string
  country: string
  postCode: string
  city: string
  street: string
  vatId: string
}

export interface IAdditionalService {
  id?: string
  id_reservation?: string
  service_name: string
  price: string
  first_tax: string
  second_tax: string
}

export { fetchEvents, makeGrid }
export type BookingCalendarList = Map<number, IEvent>
